export const COS_BASE =
  'https://test-1259412944.cos.ap-nanjing.myqcloud.com/images/'

export const ASSETS = {
  heroMain: COS_BASE + 'hero_suzhou_main.png',
  heroXinbianheNight: COS_BASE + 'hero_xinbianhe_night.png',
  logoApp: COS_BASE + 'logo_app.png',
  activityDangshanLihua: COS_BASE + 'activity_dangshan_lihua.png',
  activitySportsTour: COS_BASE + 'activity_sports_tour.png',
  activityCoupon: COS_BASE + 'ctivity_coupon.png', // Note: missing 'a'
  tourismXinbianhe: COS_BASE + 'tourism_xinbianhe.png',
  tourismHuangzangyu: COS_BASE + 'tourism_huangzangyu..png', // Note: two dots
  tourismDangshanLishu: COS_BASE + 'tourism_dangshan_lishu.png',
  tourismCaiwaRed: COS_BASE + 'tourism_caiwa_red.png',
  cultureDazexiang: COS_BASE + 'culture_dazexiang.png',
  venueMuseum: COS_BASE + 'venue_suzhou_museum.png',
  venueLibrary: COS_BASE + 'venue_library.png',
  venueArtMuseum: COS_BASE + 'venue_art_museum.png',
  foodBreakfast: COS_BASE + 'food_suzhou_breakfast.png',
  foodFulijiChicken: COS_BASE + 'food_fuliji_chicken.png',
  foodNightMarket: COS_BASE + 'food_night_market.png',
  shoppingCulturalProducts: COS_BASE + 'shopping_cultural_products.png',
  cultureLingbiStone: COS_BASE + 'culture_lingbi_stone.png',
  cultureSixianCanal: COS_BASE + 'culture_sixian_canal.png',
  cultureRedMemory: COS_BASE + 'culture_red_memory.png',
  heatmapSuzhouCity: COS_BASE + 'heatmap_suzhou_city.png',
  heatmapCountiesBg: COS_BASE + 'heatmap_counties_bg.png',
  sportsBanner: COS_BASE + 'sports_suzhou_banner.png',
  sportsVenue: COS_BASE + 'sports_venue.png',
  sportsRouteHalfday: COS_BASE + 'sports_route_halfday.png',
  detailScenicDefault: COS_BASE + 'detail_scenic_default.png',
  detailRouteDefault: COS_BASE + 'detail_route_default.png',
  searchBg: COS_BASE + 'search_bg.png',
  placeholderScenic: COS_BASE + 'placeholder_scenic.png',
  emptyState: COS_BASE + 'empty_state.png',
  iconHotel: COS_BASE + 'icon_hotel.png',
  iconFood: COS_BASE + 'icon_food.png',
  iconCulture: COS_BASE + 'icon_culture.png',
  iconHeatmap: COS_BASE + 'icon_heatmap.png',
  iconHeritage: COS_BASE + 'icon_heritage.png',
  iconHistoricSite: COS_BASE + 'icon_historic_site.png',
  iconStory: COS_BASE + 'icon_story.png',
  iconGuide: COS_BASE + 'icon_guide.png',
  iconRoute: COS_BASE + 'icon_route.png',
  iconService: COS_BASE + 'icon_service.png',
  iconElder: COS_BASE + 'icon_elder.png',
}
